import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-190f5ad2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sub" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Retornos y ")
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "sub" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "sub" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Retornos y ")
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["title"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "div" }, null, -1))

import { ref, onMounted, computed, watch } from "vue";
import type { TabsPaneContext } from "element-plus";
import { useI18n } from "vue-i18n";
import importResultComponent from "@/components/import/ImportResult.component";
import importGraphComponent from "@/components/import/ImportGraph.component";
import importTableComponent from "@/components/import/ImportTable.component";
import { Parameter } from "@/types/parameter.type";
import { getParameter } from "@/service/parameter.service";
import { getResult, getValidation } from "@/service/estimation.service";
import { Filter } from "@/types/filter.type";
import { ValidationFilter } from "@/types/estimation.type";
import { useRoute } from "vue-router";
import * as XLSX from "xlsx";
import { DataUpload } from "@/types/dataupload.type";
import { getSamPointOnlyParameters } from "@/service/samplingpoint.service";


export default /*#__PURE__*/_defineComponent({
  props: {
    csvContent: null,
    selectedValue: null,
    parameter: null,
    selectedTimeFrom: null,
    selectedTimeTo: null
  },
  setup(__props: any) {

const props = __props as {
  csvContent: string;
  selectedValue: string;
  parameter: Parameter;
  selectedTimeFrom: string;
  selectedTimeTo: string;
}

const { t } = useI18n();



let order = [
  "TU",
  "SS",
  "SD",
  "MES",
  "CE",
  "RE",
  "DQ",
  "DB",
  "CO",
  "CT",
  "NT",
  "NO",
  "OD",
  "PH",
  "FO",
  "FT",
  "OR",
  "NH",
  "FE",
  "MN",
  "AYG",
  "ES",
  "LE",
  "RET",
  "CR",
  "CR",
  "AVA",
  "AVE",
  "CL_AVA",
  "CL_AVE",
  "CL_DI",
  "CL_CR",
  "CL_T",
  "CAS_CR",
  "CAS_DI",
  "CAS_T",
];
if (props.selectedValue == "Retornos") {
  order = [
    "RET",
    "TU",
    "SS",
    "SD",
    "MES",
    "CE",
    "RE",
    "DQ",
    "DB",
    "CO",
    "CT",
    "NT",
    "NO",
    "OD",
    "PH",
    "FO",
    "FT",
    "OR",
    "NH",
    "FE",
    "MN",
    "AYG",
    "ES",
    "LE",
    "RET",
    "CR",
    "CR",
    "AVA",
    "AVE",
    "CL_AVA",
    "CL_AVE",
    "CL_DI",
    "CL_CR",
    "CL_T",
    "CAS_CR",
    "CAS_DI",
    "CAS_T",
  ];
}

const dateRange = ref("");
const selectedParameterCode = ref("");
const selectedParameterName = computed(() => {
  return (
    availableParameters.value.find((param) => param.code === selectedParameterCode.value)?.name ||
    ""
  );
});
const availableParameters = ref([] as Array<{ code: string; name: string | undefined }>);
const tableData = ref([] as Array<{ date: string; value: { [key: string]: string } }>);
const parameter = ref({} as Parameter);
const startDate = ref("");
const endDate = ref("");
const route = useRoute();
const enhancedData = ref<Array<{ date: string; value: string; ourEstimation?: string }>>([]);
let metric;
const mae = ref(0);
const mape = ref(0);

let filteredTableData = computed(() => {
  return tableData.value
    .filter((item) => item.date && item.value[selectedParameterCode.value] !== undefined)
    .map((item) => ({
      date: item.date,
      value: item.value[selectedParameterCode.value] || "-",
    }));
});

if (props.selectedValue == "Retornos") {
  filteredTableData = computed(() => {
    return (
      tableData.value
        .filter((item) => item.date && item.value["RET"] !== undefined)
        // .filter((item) => item.date && item.value["TMOA"] !== undefined)
        .map((item) => ({
          date: item.date,
          value: item.value["RET"] || "-",
          // value: item.value["TMOA"] || "-",
        }))
    );
  });
}

const processCsvData = async (csvContent: string) => {
  csvContent = csvContent.trim();
  const rows = csvContent.split("\n").map((row) => row.split(";"));

  availableParameters.value = [];

  for (let i = 1; i < rows[0].length; i++) {
    const parameterCode = rows[0][i].replace("\r", "");
    const filter: Filter = {
      fields: {
        "parameter.code": {
          operator: "equal",
          value: parameterCode,
        },
      },
    };

    const parameter = (await getParameter(undefined, undefined, filter))?.data;

    if (parameter && parameter[0]) {
      availableParameters.value.push({
        code: parameterCode,
        name: parameter[0].name,
      });
    }
  }

  if (props.selectedValue === "Retornos") {
    const samplingPointParams = await getSamPointOnlyParameters(Number(route.params.samplingPoint));

    samplingPointParams.forEach((param) => {
      if (param.name?.toLowerCase() !== "matriz de agua") {
        availableParameters.value.push({
          code: param.code || "",
          name: param.name || "",
        });
      }
    });

    const dates = rows.slice(1).map((row: any[]) => row[0]);

    if (dates[0] === dates[dates.length - 1]) {
      dateRange.value = `${dates[0]}`;
    } else {
      dateRange.value = `${dates[0]} - ${dates[dates.length - 1]}`;
    }
  }

  const uniqueParameters = Array.from(
    new Map(availableParameters.value.map((item) => [item.code?.toLowerCase(), item])).values()
  );

  availableParameters.value = uniqueParameters;

  availableParameters.value.sort((a, b) => {
    const nameA = a.code?.toLowerCase();
    const nameB = b.code?.toLowerCase();

    if (!nameA || !nameB) {
      return 0;
    }

    const indexA = order.findIndex((item) => item.toLowerCase() === nameA);
    const indexB = order.findIndex((item) => item.toLowerCase() === nameB);

    if (indexA === -1 && indexB === -1) {
      return nameA.localeCompare(nameB);
    }
    if (indexA === -1) {
      return 1;
    }
    if (indexB === -1) {
      return -1;
    }

    return indexA - indexB;
  });
  if (props.selectedValue === "Vertidos") {
    const dates = rows.slice(1).map((row: any[]) => row[0]);
    if (dates[0] === dates[dates.length - 1]) {
      dateRange.value = `${dates[0]}`;
    } else {
      dateRange.value = `${dates[0]} - ${dates[dates.length - 1]}`;
    }
  }

  if (availableParameters.value.length > 0) {
    selectedParameterCode.value = availableParameters.value[0].code;
    await processParameter();
  }

  tableData.value = rows.slice(1).map((row) => ({
    date: row[0],
    value: rows[0].reduce((acc, param, index) => {
      acc[param.replace("\r", "")] = row[index];
      return acc;
    }, {} as Record<string, string>),
  }));
};

const processParameter = async () => {
  const rows = props.csvContent.split("\n").map((row) => row.split(";"));
  const parameterIndex = rows[0].indexOf(selectedParameterCode.value);

  if (parameterIndex === -1) {
    return;
  }

  const filteredRows = rows.slice(1).filter((row) => row[0]?.trim() && row[parameterIndex]?.trim());

  const dates = filteredRows.map((row) => row[0]);
  dateRange.value = `${dates[0]} - ${dates[dates.length - 1]}`;
  updateDateRange();

  tableData.value = filteredRows.map((row) => ({
    date: row[0],
    value: {
      [selectedParameterCode.value]: row[parameterIndex].replace("\r", "").replace(",", "."),
    },
  }));

  await calculateAndPopulateEnhancedData();
};

const updateDateRange = () => {
  if (props.selectedValue !== "Muestras integradas") {
    return;
  }

  const { selectedTimeFrom, selectedTimeTo } = props;

  const extractTime = (date: string | number | Date) => {
    return date
      ? new Date(date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
      : "";
  };

  const timeFrom = extractTime(selectedTimeFrom);
  const timeTo = extractTime(selectedTimeTo);

  dateRange.value +=
    timeFrom && timeTo
      ? ` ${timeFrom} - ${timeTo}`
      : timeFrom || timeTo
      ? ` ${timeFrom || timeTo}`
      : "";
};

const calculateAndPopulateEnhancedData = async () => {
  const filter: Filter = {
    fields: {
      "parameter.code": {
        operator: "equal",
        value: selectedParameterCode.value,
      },
    },
  };

  const parameterData = (await getParameter(undefined, undefined, filter))?.data;

  if (!parameterData || !parameterData[0]) {
    throw new Error("No se encontró el parámetro seleccionado.");
  }

  const validationFilter = {
    samplingPointId: [Number(route.params.samplingPoint)],
    parameterId: [parameterData[0].id],
    date: [parseDateString(startDate.value), parseDateString(endDate.value)],
  } as unknown as ValidationFilter;

  const dataValidation: DataUpload[] = tableData.value.map((item) => ({
    dateTime: parseDateString(item.date).toISOString(),
    value: parseFloat(item.value[selectedParameterCode.value]) || 0,
    magnitude: parameterData[0]?.name || "",
    parameter: parameterData[0],
    unit: "",
    origin: "",
  }));

  const validateEstimations = await getValidation(
    undefined,
    undefined,
    validationFilter,
    dataValidation
  );

  const validationMap = new Map(
    validateEstimations.data.map((element: { estimation: any; dateTime: any }) => [
      element.dateTime,
      element.estimation,
    ])
  );

  enhancedData.value = tableData.value.map((item) => ({
    date: item.date,
    value: parseFloat(item.value[selectedParameterCode.value]).toFixed(2) || "-",
    ourEstimation: validationMap.get(parseDateString(item.date).toISOString())?.toFixed(2) || "-",
  }));
};

const downloadExcel = async () => {
  if (enhancedData.value.length === 0) {
    await calculateAndPopulateEnhancedData();
  }

  const estimationsMap = new Map(enhancedData.value.map((item) => [item.date, item.ourEstimation]));

  const datos = tableData.value.map((item) => {
    const estimacion = estimationsMap.get(item.date) || "-";
    let valor: number | string = item.value[selectedParameterCode.value];

    if (valor) {
      valor = valor.toString().replace(",", ".");
      valor = parseFloat(valor).toFixed(2);
    } else {
      valor = "-";
    }

    const diferencia =
      estimacion !== "-" && valor !== "-"
        ? Math.abs(Number(estimacion.replace(",", ".")) - Number(valor.replace(",", ".")))
            .toFixed(2)
            .replace(".", ",")
        : "-";

    const formattedEstimacion = estimacion !== "-" ? estimacion.replace(".", ",") : "-";
    const formattedValor = valor !== "-" ? valor.replace(".", ",") : "-";

    return {
      Fecha: item.date,
      "Estimaciones de Aquacorp": formattedEstimacion,
      "Medidas de referencia de laboratorio": formattedValor,
      Diferencia: diferencia,
    };
  });

  // Crear hoja para los datos
  const hojaDeCalculo = XLSX.utils.json_to_sheet(datos);

  // Configurar el ancho de las columnas
  hojaDeCalculo["!cols"] = [{ width: 20 }, { width: 25 }, { width: 32 }, { width: 15 }];
  metric = await calculateResult();

  // Crear encabezados
  const encabezados = [[selectedParameterName.value], ["MAE", mae.value], ["MAPE", mape.value]];

  const hojaDeEncabezados = XLSX.utils.aoa_to_sheet(encabezados);

  // Configurar ancho de columnas para los encabezados
  hojaDeEncabezados["!cols"] = [{ width: 15 }, { width: 15 }];

  // Crear libro y añadir hojas
  const hojaDeTrabajo = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(hojaDeTrabajo, hojaDeCalculo, selectedParameterName.value);
  XLSX.utils.book_append_sheet(hojaDeTrabajo, hojaDeEncabezados, "Datos");

  // Crear archivo Excel y descargar
  const archivoExcel = XLSX.write(hojaDeTrabajo, { bookType: "xlsx", type: "array" });
  const blob = new Blob([archivoExcel], { type: "application/octet-stream" });
  const enlace = document.createElement("a");
  enlace.href = URL.createObjectURL(blob);
  enlace.download = `${selectedParameterName.value}_Validacion.xlsx`;

  document.body.appendChild(enlace);
  enlace.click();
  document.body.removeChild(enlace);
};

const calculateResult = async () => {
  const filter: Filter = {
    fields: {
      "parameter.code": {
        operator: "equal",
        value: selectedParameterCode.value,
      },
    },
  };
  const parameter = (await getParameter(undefined, undefined, filter))?.data;

  if (!parameter || !parameter[0]) {
    throw new Error("No se encontró el parámetro seleccionado.");
  }

  const validationFilter = {
    samplingPointId: [Number(route.params.samplingPoint)],
    parameterId: [parameter[0].id],
    date: [parseDateString(startDate.value), parseDateString(endDate.value)],
  } as unknown as ValidationFilter;

  const dataValidation: DataUpload[] = tableData.value.map((item) => ({
    dateTime: parseDateString(item.date).toISOString(),
    value: parseFloat(item.value[selectedParameterCode.value]) || 0,
    magnitude: parameter[0]?.name || "",
    parameter: parameter[0],
    unit: "",
    origin: "",
  }));

  const metric = await getResult(validationFilter, dataValidation);
  mae.value = metric.mae;
  mape.value = metric.mape;
};

function parseDateString(dateString: string): Date {
  const [datePart, timePart] = dateString.split(" ");
  const [day, month, year] = datePart.split("/").map(Number);

  let hour = 0,
    minute = 0,
    second = 0;

  if (timePart) {
    [hour, minute, second = 0] = timePart.split(":").map(Number);
  }
  return new Date(year, month - 1, day, hour, minute, second);
}

watch(selectedParameterCode, async () => {
  if (selectedParameterCode.value) {
    await processParameter();
  }
});

onMounted(async () => {
  await processCsvData(props.csvContent);
  metric = await calculateResult();
  // mae.value = metric.mae;
  // mape.value = metric.mape;
});

const activeName = ref("first");

const handleClick = (tab: TabsPaneContext, event: Event) => {
  console.log(tab, event);
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, {
      modelValue: activeName.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((activeName).value = $event)),
      type: "card",
      class: "demo-tabs",
      onTabClick: handleClick
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: _unref(t)('label.graph'),
          name: "first"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (__props.selectedValue == 'Retornos')
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _hoisted_3,
                    _createVNode(_component_el_select, {
                      modelValue: selectedParameterCode.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedParameterCode).value = $event)),
                      placeholder: "Select Parameter",
                      onChange: processParameter,
                      class: "selectParameter"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableParameters.value, (param) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: param.code,
                            label: param.name == 'Retorno' ? '-' : param.name,
                            value: param.code
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createTextVNode("(" + _toDisplayString(dateRange.value) + ") ", 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_el_select, {
                      modelValue: selectedParameterCode.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedParameterCode).value = $event)),
                      placeholder: "Select Parameter",
                      onChange: processParameter,
                      class: "selectParameter"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableParameters.value, (param) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: param.code,
                            label: param.name,
                            value: param.code
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createTextVNode("(" + _toDisplayString(dateRange.value) + ") ", 1)
                  ]))
            ]),
            (activeName.value === 'first')
              ? (_openBlock(), _createBlock(_unref(importGraphComponent), {
                  key: 0,
                  dataClient: _unref(filteredTableData),
                  parameterImport: parameter.value,
                  csvContent: __props.csvContent,
                  selectedValue: __props.selectedValue,
                  selectedTimeFrom: props.selectedTimeFrom,
                  selectedTimeTo: props.selectedTimeTo,
                  nameParameter: _unref(selectedParameterName)
                }, null, 8, ["dataClient", "parameterImport", "csvContent", "selectedValue", "selectedTimeFrom", "selectedTimeTo", "nameParameter"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label"]),
        (__props.selectedValue == 'Validación')
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 0,
              label: _unref(t)('label.results'),
              name: "second"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_select, {
                    modelValue: selectedParameterCode.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedParameterCode).value = $event)),
                    placeholder: "Select Parameter",
                    onChange: processParameter,
                    class: "selectParameter"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableParameters.value, (param) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: param.code,
                          label: param.name,
                          value: param.code
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createTextVNode("(" + _toDisplayString(dateRange.value) + ") ", 1)
                ]),
                (activeName.value === 'second')
                  ? (_openBlock(), _createBlock(_unref(importResultComponent), {
                      key: 0,
                      dataClient: _unref(filteredTableData),
                      parameterImport: parameter.value,
                      nameParameter: _unref(selectedParameterName),
                      selectedValue: __props.selectedValue,
                      csvContent: __props.csvContent,
                      selectedTimeFrom: props.selectedTimeFrom,
                      selectedTimeTo: props.selectedTimeTo
                    }, null, 8, ["dataClient", "parameterImport", "nameParameter", "selectedValue", "csvContent", "selectedTimeFrom", "selectedTimeTo"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_tab_pane, {
          label: _unref(t)('label.table'),
          name: "third"
        }, {
          default: _withCtx(() => [
            (__props.csvContent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (__props.selectedValue == 'Retornos')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _hoisted_9,
                          _createVNode(_component_el_select, {
                            modelValue: selectedParameterCode.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedParameterCode).value = $event)),
                            placeholder: "Select Parameter",
                            onChange: processParameter,
                            class: "selectParameter"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableParameters.value, (param) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: param.code,
                                  label: param.name == 'Retorno' ? '-' : param.name,
                                  value: param.code
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createTextVNode("(" + _toDisplayString(dateRange.value) + ") ", 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_component_el_select, {
                            modelValue: selectedParameterCode.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedParameterCode).value = $event)),
                            placeholder: "Select Parameter",
                            onChange: processParameter,
                            class: "selectParameter"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableParameters.value, (param) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: param.code,
                                  label: param.name,
                                  value: param.code
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createTextVNode("(" + _toDisplayString(dateRange.value) + ") ", 1)
                        ]))
                  ]),
                  (activeName.value === 'third')
                    ? (_openBlock(), _createBlock(_unref(importTableComponent), {
                        key: 0,
                        dataClient: _unref(filteredTableData),
                        selectedValue: __props.selectedValue,
                        csvData: props.csvContent,
                        nameParameter: _unref(selectedParameterName),
                        selectedTimeFrom: props.selectedTimeFrom,
                        selectedTimeTo: props.selectedTimeTo
                      }, null, 8, ["dataClient", "selectedValue", "csvData", "nameParameter", "selectedTimeFrom", "selectedTimeTo"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label"]),
        (__props.selectedValue == 'Validación')
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: downloadExcel,
              class: "download-icon"
            }, [
              _createElementVNode("i", {
                class: "el-icon el-icon-download fas btn",
                title: _ctx.$t('btn.downloadCSV')
              }, null, 8, _hoisted_11)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _hoisted_12
  ]))
}
}

})